import React from 'react';
import styled from 'styled-components';
import CheckIcon from './icons/CheckIcon';

type PackageCardProps = {
  title: React.ReactNode;
  price: string;
  features: React.ReactNode[];
  onChoose: () => void;
  className?: string;
  buttonLabel?: React.ReactNode;
};

const Card = styled.div`
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  /* Static width on tablet/desktop to prevent sizing changes based on text */
  width: 320px;
  max-width: 100%;

  /* Keep the same fixed width on mobile as well, per request. */

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(236, 92, 44, 0.2);
  }
`;

const CardHeader = styled.div`
  background: linear-gradient(45deg, var(--primary-orange), #ff7043);
  color: white;
  padding: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
`;

const CardBody = styled.div`
  padding: 2rem;
`;

const Price = styled.p`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-orange);
  text-align: center;
  margin-bottom: 1.5rem;
  white-space: nowrap; /* keep euro and amount on one line */
`;

const FeatureList = styled.div`
  margin-bottom: 2rem;
`;

const FeatureItem = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  svg {
    color: #28a745;
    margin-right: 0.75rem;
    font-size: 1.2rem;
    flex-shrink: 0;
  }
`;

const ChooseButton = styled.button`
  width: 100%;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: var(--primary-orange);
    transform: translateY(-2px);
  }
`;

const PackageCard: React.FC<PackageCardProps> = ({ title, price, features, onChoose, className, buttonLabel }) => {
  return (
    <Card className={className}>
      <CardHeader>{title}</CardHeader>
      <CardBody>
        <Price>{price}</Price>
        <FeatureList>
          {features.map((feat, idx) => (
            <FeatureItem key={`feat-${idx}`}>
              <CheckIcon aria-hidden="true" />
              {feat}
            </FeatureItem>
          ))}
        </FeatureList>
        <ChooseButton onClick={onChoose}>
          {buttonLabel || 'Choose'}
        </ChooseButton>
      </CardBody>
    </Card>
  );
};

export default PackageCard;
